<template>
  <div :class="$style.popup">
    <div :class="$style.overlay" @click="$emit('set-modal', false)"></div>
    <div :class="$style.content" @click.stop>
      <div :class="$style.close" @click.stop="$emit('set-modal', false)">
        <img src="/icons/grey-cross.svg" alt="" />
      </div>
      <div :class="$style.body">
        <div :class="$style.top">
          <img src="/icons/notification-icon.svg" alt="" />
          <div>Добавить напоминание</div>
        </div>
        <div :class="$style.textarea">
          <textarea
            v-model="text"
            placeholder="Сообщение напоминания..."
          ></textarea>
        </div>
        <div :class="$style.bottom">
          <div>
            <div :class="[$style.date]">
              <div :class="[$style.from]" class="from">
                <div :class="[$style.dateValue, { [$style.active]: from }]">
                  <img src="/icons/picker.svg" alt="" />
                  <p>
                    {{ from.length ? from : "Дата и время" }}
                  </p>
                </div>

                <VueCtkDateTimePicker
                  id="from"
                  ref="from"
                  v-model="from"
                  autoClose
                  locale="ru"
                  label="Дата"
                  inputSize="lg"
                  color="#34c759"
                  minute-interval="1"
                  :no-button-now="true"
                  format="YYYY-MM-DD HH:mm"
                  @is-shown="openPicker"
                  :min-date="formatData"
                />
              </div>
            </div>
          </div>
          <div @click="create" :class="$style.button">Добавить</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  data() {
    return {
      from: "",
      text: "",
      formatData: "",
    };
  },
  components: {
    VueCtkDateTimePicker,
  },
  methods: {
    async create() {
      if (this.text && this.from) {
        await this.$store.dispatch("createNotification", {
          message: this.text,
          project: this.lead.id,
          time_to_notify: this.from,
        });
        this.text = "";
        this.from = "";
        this.$emit("set-modal", false);
      }
    },
    openPicker() {
      function padTo2Digits(num) {
        return num.toString().padStart(2, "0");
      }

      function formatDate(date) {
        return (
          [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
          ].join("-") +
          " " +
          [padTo2Digits(date.getHours()), padTo2Digits(date.getMinutes())].join(
            ":"
          )
        );
      }

      this.formatData = formatDate(new Date());
    },
  },
  computed: {
    lead() {
      return this.$store.state.leads.lead;
    },
  },
};
</script>

<style lang="scss" module>
@keyframes expand {
  from {
    transform: scale(0.7);
    opacity: 0;
    background: #5470b0;
  }
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 2;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    transition: opacity 0.3ms;
    z-index: 2;
    animation: expand 0.3s ease-in-out;
  }
  .close {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
  .content {
    //overflow: auto;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100vh - 5rem);
    max-width: 30rem;
    width: 100%;
    background: $t-white;
    border-radius: 1rem;
    z-index: 3;
    animation: expand 0.2s ease-in-out;
    padding: 1rem 0;
    @include scrollbarY;
    @include custom(632) {
      width: calc(100vw - 2rem);
      max-width: none;
    }
    @include custom(550) {
      padding: 1.5rem;
    }
    .top {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      @include Title;
      padding: 0 1rem 1rem 1rem;
      border-bottom: 1px solid $bg-separator;
    }
    .textarea {
      height: 8rem;
      textarea {
        width: 100%;
        height: 100%;
        background-color: $bg-primary;
        border: none;
        outline: 0;
        padding: 1rem;
        @include Body2;
        &::placeholder {
          @include Body2;
          color: $t-secondary;
        }
      }
    }
    .bottom {
      display: flex;
      gap: 1.5rem;
      justify-content: space-between;
      padding: 1rem 1rem 0 1rem;
      .button {
        @include ButtonText;
        color: $t-secondary;
        background-color: $bg-primary;
        padding: 0.75rem 1.5rem;
        border-radius: 6.25rem;
        cursor: pointer;
      }
      .date {
        .from,
        .before {
          position: relative;
          .dateValue {
            height: 2.5rem;
            @include Subtitle;
            color: $t-secondary;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 1px solid $bg-separator;
            gap: 0.5rem;
            border-radius: 0.25rem;
            padding: 0 1rem;
            width: 100%;
            cursor: pointer;
            p {
              flex: 1 1 auto;
              position: relative;
              width: 100%;
              z-index: 3;
            }
            img {
              position: relative;
              z-index: 2;
            }
            &.active {
              p {
                color: $t-primary;
                @include Subtitle;
              }
            }
          }

          input {
            opacity: 0;
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 5;
          }
          label {
            display: none;
          }
        }
        &.error {
          p {
            color: $red;
          }
          .from {
            .dateValue {
              border: 1px solid $red;
            }
          }
        }
      }
    }
  }
}
</style>
